import axios from "axios";

const CMS_BASE_URL = `${process.env.REACT_APP_CMS_BASEURL}`;

export function getSmartReportData() {


  return axios.get(`${CMS_BASE_URL}smartreport-news?populate=first,third,third.thirdsub,fourth,fourth.fourthsub,fifth,fifth.fifthsub,sixth,sixth.sixthsub`, 
  );
 
 
}